export function isElectron() {
    return window.electron !== undefined
}